import { Card, Text } from "@portal/components/primitives";
import { FC } from "react";
import { AccountTabProps } from "../../account/AccountLayout";
import { AccountBondsTable } from "./AccountBondsTable";

type AccountBondsTabProps = AccountTabProps;

export const AccountBondsTab: FC<AccountBondsTabProps> = ({ accountId }) => {
	return (
		<div className="flex flex-col pb-[125px]" data-testid="agent-account-bonds-tab">
			<Card elevation="raised" className="rounded-xl" data-testid="agent-account-bonds-card">
				<Card.Body className="flex flex-col space-y-5 p-6">
					<Text type="title" color="primary">
						Bonds
					</Text>
					<AccountBondsTable accountId={accountId} tableName="account_bonds" />
				</Card.Body>
			</Card>
		</div>
	);
};
